import { Component, OnDestroy } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { SessionTimeoutService } from './common/services/session-timeout.service';
import { SessionDialogComponent } from './dialogs/dialog-session/session-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnDestroy {
  username = '';

  constructor(private authService: MsalService, private dialog: MatDialog, private session: SessionTimeoutService) {
    this.session.start({
      idleMs: parseInt(environment.SessionTimeout),
      onTimeout: async () => {
        const ref = this.dialog.open(SessionDialogComponent, {
        width: '420px',
        disableClose: false,
        data: this.session.remainingSeconds$
      });
      ref.afterClosed().subscribe(choice => {
        if (choice === 'stay')
          this.session.resetTimers();
        else if (choice === 'logout') {
          const account = this.authService.instance.getActiveAccount();
          this.authService.logoutRedirect({ account: account });
        }
      });
      },
    });
  }

  ngOnDestroy(): void {
    this.session.stop();
  }

  logout(): void {
    this.authService.logoutRedirect();
  }
}
